<template>
  <div class="device-progress-info">
    <!-- 消息单独一行 -->
    <div class="progress-msg" v-if="oneProgress && oneProgress.msg">
      {{ oneProgress.msg }}
    </div>
    
    <!-- 进度条和计数在同一行 -->
    <div class="progress-content" v-if="oneProgress">
      <div class="progress-bar">
        <Progress 
          text-inside 
          :percent="calOnePercent(oneProgress)" 
          :stroke-width="16"
          :stroke-color="getProgressColor(oneProgress.status)"
          :status="getProgressStatus(oneProgress.status)">
        </Progress>
      </div>
      <div class="progress-count">
        {{ oneProgress.processed }}/{{ oneProgress.total }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Progress } from 'view-design'
export default {
  name: 'LineProgress',
  computed: {
    ...mapGetters(['getTranslation'])
  },
  components: {
    Progress
  },
  props: {
    oneProgress: Object,
  },
  methods: {
    calOnePercent(oneProgress) {

      if (oneProgress && oneProgress.total > 0) {

        let percent = Math.floor((oneProgress.processed / oneProgress.total) * 100);

        return percent;
      } else {
        return 0;
      }
    },

    getProgressColor(status) {
      const statusClass = this.getStatusClass(status);
      switch (statusClass) {
        case 'success':
          return '#52c41a';
        case 'failed':
          return '#f5222d';
        case 'running':
          return '#1890ff';
        default:
          return '#515a6e';
      }
    },

    getProgressStatus(status) {
      const statusClass = this.getStatusClass(status);
      switch (statusClass) {
        case 'success':
          return 'success';
        case 'failed':
          return 'wrong';
        case 'running':
          return 'active';
        default:
          return 'normal';
      }
    },
    getStatusClass(status) {
      if (!status) return 'waiting';
      const statusStr = status.toLowerCase();
      if (statusStr.includes('success')) {
        return 'success';
      } else if (statusStr.includes('failed') || statusStr.includes('error')) {
        return 'failed';
      } else if (statusStr.includes('running')) {
        return 'running';
      } else {
        return 'waiting';
      }
    },
  }
}
</script>

<style scoped>
.device-progress-info {
  width: 100%;
}

.progress-msg {
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  line-height: 1.4;
  word-break: break-word; /* 长文本自动换行 */
}

.progress-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progress-bar {
  flex: 1;
}

.progress-count {
  min-width: 60px;
  text-align: right;
  white-space: nowrap;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}
.progress-msg {
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  line-height: 1.4;
  word-break: break-word; /* 长文本自动换行 */
}
</style>